class ProductStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    // Header
    this.header = document.querySelector("#shopify-section-header");
    this.headerHeight = this.header.clientHeight;

    // Buy button
    this.buyButton = document.querySelector("[data-track-add-to-cart]");
    this.buyButtonHeight = this.buyButton.clientHeight;

    this.debouncedOnLoad = debounce((event) => {
      // when bottom is reached, hide the bar. Use math because it can return a half pixel...
      if (
        event.type === "scroll" &&
        window.innerHeight + Math.round(window.scrollY) >=
          document.body.offsetHeight
      ) {
        this.removeActiveClassToBody();
        return;
      }
      this.showBar();
    }, 10);

    ["load", "scroll"].forEach((eventListener) => {
      window.addEventListener(eventListener, this.debouncedOnLoad.bind(this));
    });


  }

  /**
   * Show bar
   */
  showBar() {
    this.stickyAtc();

    document.addEventListener(
      "scroll",
      function () {
        this.stickyAtc();
      }.bind(this),
      {
        passive: true,
      }
    );
  }

  /**
   * Check element in view function
   */
  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /**
   * sticky add to cart button function
   */
  stickyAtc() {
    const product_form = document.querySelector("[data-track-add-to-cart]");
    let drawerElement = document.querySelector("body");
    if (drawerElement && !drawerElement.classList.contains('cart-drawer-is-open')) {
    this.isInViewport(product_form)
      ? this.removeActiveClassToBody()
      : this.addActiveClassToBody();
    }
  }

  /**
   * Add active class to the body
   */
  addActiveClassToBody() {
    if (!document.body.classList.contains("sticky-add-to-cart--active")) {
      document.body.classList.add("sticky-add-to-cart--active");
      let beacons = document.querySelectorAll(".BeaconFabButtonFrame");
      if (beacons) {
        if (window.screen.width >= 768) {
          beacons.forEach((element) => {
            element.style.bottom = "90px";
          });
        }
        else {
          beacons.forEach((element) => {
            element.style.bottom = "140px";
          });
        }

      }
    }

  }

  /**
   * Remove active class to the body
   */
  removeActiveClassToBody() {
    if (document.body.classList.contains("sticky-add-to-cart--active")) {
      document.body.classList.remove("sticky-add-to-cart--active");
      let beacons = document.querySelectorAll(".BeaconFabButtonFrame");
      beacons.forEach((element) => {
        element.style.bottom = "40px";
      });


  
    }
  }
}

if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", ProductStickyAddToCart);
}
